import Model from './BaseModel'
import i18n from '@/plugins/i18n'
import User from './User'
import Reseller from './Reseller'
import moment from 'moment'

export default class ActionLog extends Model {
    resourceName() {
        return 'action-logs'
    }

    fields() {
        return [
            'resource',
            'action',
            'user_id',
            'type',
            'actionable_id',
            'original',
            'changes',
            'actioned_at',
        ]
    }

    relationships() {
        return {
            user: new User(),
            reseller: new Reseller(),
        }
    }

    formatDate(stringDate) {
        return moment(stringDate).format('DD/MM/YYYY H:mm:ss')
    }

    computed() {
        return {
            logAction(log) {
                return i18n.t(`action-log.attributes.action.${log.action}`)
            },

            userName(log) {
                if (!(log.user instanceof Model))
                    return i18n.t('action-log.attributes.userName.system')

                let name = log.user.name

                if (log.reseller instanceof Model) {
                    name = '[' + log.reseller.tenant_code + '] - ' + name
                }

                return name
            },

            formatedResume(log) {
                return (
                    log.userName +
                    ' ' +
                    log.logAction.toLowerCase() +
                    ' um registro ' +
                    ' em ' +
                    log.formatDate(log.actioned_at)
                )
            },
        }
    }

    get searchable() {
        return ['search']
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('action-log.index.table.userName'),
                sortable: false,
                value: 'userName',
            },
            {
                text: i18n.t('action-log.index.table.action'),
                sortable: false,
                value: 'logAction',
            },
            {
                text: i18n.t('action-log.index.table.resource'),
                sortable: false,
                value: 'resource',
            },
            {
                text: i18n.t('action-log.index.table.actionable_id'),
                value: 'actionable_id',
            },
            {
                text: i18n.t('action-log.index.table.actioned_at'),
                value: 'actioned_at',
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }
}
